import React from "react";
import PropTypes from "prop-types";

import { Row, Col } from "react-bootstrap";
import { IoAdd } from "react-icons/io5";

const TimesheetFooter = ({ addRow }) => (
  <Row>
    <Col md={12} className="footer">
      <button
        className="btn btn-default pull-left"
        type="button"
        onClick={addRow}
        style={{
          display: "flex"
        }}
      >
        <IoAdd size={18} /> Row
      </button>
    </Col>
  </Row>
);
TimesheetFooter.propTypes = {
  addRow: PropTypes.func
};

export default TimesheetFooter;
